import apiClient from "./apiClient";

export const fetchStations = async () => {
    const response = await apiClient.get("/api/gas_stations/all");
    return response.data;
};

export const createStation = async (stationData) => {
    const response = await apiClient.post("/api/gas_stations", stationData);
    return response.data;
};

export const updateStation = async (id, stationData) => {
    const response = await apiClient.put(`/api/gas_stations/${id}`, stationData);
    return response.data;
};

export const deleteStation = async (id) => {
    await apiClient.delete(`/api/gas_stations/${id}`);
};